// extracted by mini-css-extract-plugin
export default {"mainItem":"BurgerConstructorItem_mainItem__7GLT1"};